<script setup lang="ts">
import OrderCard from "@/components/orders/OrderCard.vue";
import { Order } from "@/data/interfaces/OrderInterface";
import { defineProps, PropType, ref } from "vue";
import store from "@/store";
import { DbButton } from "@db-ui/v-elements-enterprise/dist/components";

defineEmits(["refreshData"]);

const props = defineProps({
  orders: Array as PropType<Order[]>,
  readonly: {
    default: false,
  },
});

const activeOrder = ref(null as string | null);

const setActiveOrder = (index: string) => {
  activeOrder.value = index;
};
</script>

<template>
  <div
    v-if="store?.state?.OrderStore?.orders.length"
    id="orders"
    class="flex flex-col gap-3 pb-[150px]"
  >
    <OrderCard
      v-for="(order, index) in orders"
      :key="index"
      :index="index"
      :order="(order as Order)"
      :readonly="readonly"
      :active-order="(activeOrder as number | null)"
      @refreshData="$emit('refreshData')"
      @activeOrder="setActiveOrder"
    ></OrderCard>
  </div>
  <div class="absolute z-1 inset-0 flex items-center justify-center" v-else>
    <span class="text-gray-500 w-40">{{ $t("order.empty") }}</span>
  </div>
  <div
    v-if="activeOrder == null && !readonly"
    id="order-button"
    class="fixed z-19 bottom-[80px] left-1/2 transform -translate-x-1/2 -translate-y-1/2"
  >
    <db-button
      @click="$router.push('/orders/create')"
      class="hydrated"
      variant="brand-primary"
    >
      {{ $t("order.add") }}
    </db-button>
  </div>
</template>
